import React from 'react';
import PropTypes from 'prop-types';

function getClass(props, type) {
  let arr = [type];
  if (props.cols) arr.push(`${type}-${props.cols}`);
  if (props.mcols) arr.push(`${type}-${props.mcols}--m`);
  if (props.start) arr.push(`${type}-start-${props.start}`);
  if (props.end) arr.push(`${type}-end-${props.end}`);
  if (props.span) arr.push(`${type}-span-${props.span}`);
  if (props.mspan) arr.push(`${type}-span-${props.mspan}--m`);
  if (props.auto) arr.push(`${type}--auto`);
  if (props.center) arr.push(`${type}--center`);
  if (props.middle) arr.push(`${type}--middle`);
  if (props.right) arr.push(`${type}--right`);
  if (props.hidden) arr.push('hidden');
  if (props.gap) arr.push(`${type}--gap-${props.gap}`);
  if (props.className) arr.push(props.className);
  return arr.join(' ');
}

function Grid(props) {
  return (
    <div
      draggable={props.draggable ? true : false}
      className={getClass(props, 'grid')}
      style={props.style ? props.style : {}}
      onDragStart={props.drag ? props.drag : null}
      onDragOver={props.dragOver ? props.dragOver : null}
    >
      {props.children && props.children}
    </div>
  );
}
Grid.propTypes = {
  className: PropTypes.string,
  auto: PropTypes.bool,
  gap: PropTypes.string,
  cols: PropTypes.string,
  mcols: PropTypes.string,
  style: PropTypes.object,
  middle: PropTypes.bool,
  hidden: PropTypes.bool,
  center: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  draggable: PropTypes.bool,
  drag: PropTypes.func,
  dragOver: PropTypes.func
};

function Col(props) {
  return (
    <div
      className={getClass(props, 'col')}
      style={props.style ? props.style : {}}
    >
      {props.children && props.children}
    </div>
  );
}
Col.propTypes = {
  className: PropTypes.string,
  auto: PropTypes.bool,
  start: PropTypes.string,
  end: PropTypes.string,
  span: PropTypes.string,
  mspan: PropTypes.string,
  right: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export { Grid, Col };



// WEBPACK FOOTER //
// ./src/components/ui/Grid.jsx